module.exports = __webpack_public_path__ + "img/warrior_m.2c5bd27c.png";